import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/mock";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = TESTIMONIALS[idx];

  return (
    <div className="relative bg-gradient-to-br from-rose-50 via-orange-50 to-amber-50 rounded-xl py-14 px-8 md:px-16 overflow-hidden">
      <Quote className="absolute top-6 left-8 w-16 h-16 text-rose-200/70" />
      <div className="relative max-w-3xl mx-auto text-center">
        <img src={t.avatar} alt={t.name} className="w-20 h-20 rounded-full mx-auto mb-5 object-cover ring-4 ring-white shadow-lg" />
        <p className="text-xl md:text-2xl font-medium text-zinc-800 leading-relaxed italic mb-6">
          “{t.quote}”
        </p>
        <div className="text-base font-semibold text-zinc-900">{t.name}</div>
        <div className="text-sm text-zinc-500">{t.role}</div>
      </div>
      <div className="flex items-center justify-center gap-4 mt-8">
        <button onClick={() => setIdx((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)} className="w-10 h-10 rounded-full bg-white shadow hover:bg-rose-500 hover:text-white flex items-center justify-center transition-colors">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <div className="flex gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} className={`h-2 rounded-full transition-all ${i === idx ? "w-8 bg-rose-500" : "w-2 bg-rose-200"}`} />
          ))}
        </div>
        <button onClick={() => setIdx((i) => (i + 1) % TESTIMONIALS.length)} className="w-10 h-10 rounded-full bg-white shadow hover:bg-rose-500 hover:text-white flex items-center justify-center transition-colors">
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default Testimonials;
